import {
  BetaContext,
  createBetaFlags,
} from '@insights-ltd/design-library/components';
import { useContext } from 'react';

export const BETA_DEFAULT = false;

const PRODUCTION_HOSTNAME = 'experience.insights.com';

export const getBetaAvailable = () => {
  return window.location.hostname !== PRODUCTION_HOSTNAME;
};

/*
When adding a new beta feature, add its name here.
When releasing a beta feature to production, remove it from here and TypeScript
will fail the build until every usage of it is removed.
 */
export type FEATURE =
  | 'impact-profile'
  | 'conscious-persona-analysis'
  | 'less-conscious-persona-analysis'
  | 'critical-thinking-enhance-your-thinking'
  | never;

const { useBetaEnabled: useBetaEnabledInternal } = createBetaFlags<FEATURE>();

export function useBetaEnabled(feature: FEATURE) {
  return useBetaEnabledInternal(feature);
}

export type Support = 'No Support' | 'Beta Support' | 'Supported';
export const NO_SUPPORT: Support = 'No Support';
export const BETA_CONFIG_SUPPORT: Support = 'Beta Support';
export const SUPPORTED: Support = 'Supported';

export const useSupport = (support?: Support): boolean => {
  const { betaEnabled } = useContext(BetaContext) ?? { betaEnabled: false };
  return (
    support === SUPPORTED || (support === BETA_CONFIG_SUPPORT && betaEnabled)
  );
};
